module.exports = {
          srcSet: __webpack_public_path__ + "37e98989.jpg"+" 700w"+","+__webpack_public_path__ + "409e0ab3.jpg"+" 1400w"+","+__webpack_public_path__ + "54bc8303.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "37e98989.jpg",width: 700,height: 465},{path: __webpack_public_path__ + "409e0ab3.jpg",width: 1400,height: 930},{path: __webpack_public_path__ + "54bc8303.jpg",width: 2048,height: 1361}],
          src: __webpack_public_path__ + "37e98989.jpg",
          toString:function(){return __webpack_public_path__ + "37e98989.jpg"},
          
          width: 700,
          height: 465
        }